'use es6';

import ComponentData from './ComponentData';
import ScoreUtil from '../../util/ScoreUtil';
class OverallData extends ComponentData {
  setGradeType(grade) {
    this.gradeType = ScoreUtil.getOverallGradeType(grade);
  }
}
export default OverallData;